var phoneList = [{code:'us',mcode:'+1',key:'USA +1'},
{code:'gb',mcode:'+44',key:'UK +44'},
{code:'dz',mcode:'+213',key:'Algeria +213'},
{code:'ad',mcode:'+376',key:'Andorra +376'},
{code:'ao',mcode:'+244',key:'Angola +244'},
{code:'ai',mcode:'+1264',key:'Anguilla +1264'},
{code:'ag',mcode:'+1268',key:'Antigua &amp; Barbuda +1268'},
{code:'ar',mcode:'+54',key:'Argentina +54'},
{code:'am',mcode:'+374',key:'Armenia +374'},
{code:'aw',mcode:'+297',key:'Aruba +297'},
{code:'au',mcode:'+61',key:'Australia +61'},
{code:'at',mcode:'+43',key:'Austria +43'},
{code:'az',mcode:'+994',key:'Azerbaijan +994'},
{code:'bs',mcode:'+1242',key:'Bahamas +1242'},
{code:'bh',mcode:'+973',key:'Bahrain +973'},
{code:'bd',mcode:'+880',key:'Bangladesh +880'},
{code:'bb',mcode:'+1246',key:'Barbados +1246'},
{code:'by',mcode:'+375',key:'Belarus +375'},
{code:'be',mcode:'+32',key:'Belgium +32'},
{code:'bz',mcode:'+501',key:'Belize +501'},
{code:'bj',mcode:'+229',key:'Benin +229'},
{code:'bm',mcode:'+1441',key:'Bermuda +1441'},
{code:'bt',mcode:'+975',key:'Bhutan +975'},
{code:'bo',mcode:'+591',key:'Bolivia +591'},
{code:'ba',mcode:'+387',key:'Bosnia Herzegovina +387'},
{code:'bw',mcode:'+267',key:'Botswana +267'},
{code:'br',mcode:'+55',key:'Brazil +55'},
{code:'bn',mcode:'+673',key:'Brunei +673'},
{code:'bg',mcode:'+359',key:'Bulgaria +359'},
{code:'bf',mcode:'+226',key:'Burkina Faso +226'},
{code:'bi',mcode:'+257',key:'Burundi +257'},
{code:'kh',mcode:'+855',key:'Cambodia +855'},
{code:'cm',mcode:'+237',key:'Cameroon +237'},
{code:'ca',mcode:'+1',key:'Canada +1'},
{code:'cv',mcode:'+238',key:'Cape Verde Islands +238'},
{code:'ky',mcode:'+1345',key:'Cayman Islands +1345'},
{code:'cf',mcode:'+236',key:'Central African Republic +236'},
{code:'cl',mcode:'+56',key:'Chile +56'},
{code:'cn',mcode:'+86',key:'China +86'},
{code:'co',mcode:'+57',key:'Colombia +57'},
{code:'km',mcode:'+269',key:'Comoros +269'},
{code:'cg',mcode:'+242',key:'Congo +242'},
{code:'ck',mcode:'+682',key:'Cook Islands +682'},
{code:'cr',mcode:'+506',key:'Costa Rica +506'},
{code:'hr',mcode:'+385',key:'Croatia +385'},
{code:'cu',mcode:'+53',key:'Cuba +53'},
{code:'cy',mcode:'+90',key:'Cyprus - North +90'},
{code:'cy',mcode:'+357',key:'Cyprus - South +357'},
{code:'cz',mcode:'+420',key:'Czech Republic +420'},
{code:'dk',mcode:'+45',key:'Denmark +45'},
{code:'dj',mcode:'+253',key:'Djibouti +253'},
{code:'dm',mcode:'+1809',key:'Dominica +1809'},
{code:'do',mcode:'+1809',key:'Dominican Republic +1809'},
{code:'ec',mcode:'+593',key:'Ecuador +593'},
{code:'eg',mcode:'+20',key:'Egypt +20'},
{code:'sv',mcode:'+503',key:'El Salvador +503'},
{code:'gq',mcode:'+240',key:'Equatorial Guinea +240'},
{code:'er',mcode:'+291',key:'Eritrea +291'},
{code:'ee',mcode:'+372',key:'Estonia +372'},
{code:'et',mcode:'+251',key:'Ethiopia +251'},
{code:'fk',mcode:'+500',key:'Falkland Islands +500'},
{code:'fo',mcode:'+298',key:'Faroe Islands +298'},
{code:'fj',mcode:'+679',key:'Fiji +679'},
{code:'fi',mcode:'+358',key:'Finland +358'},
{code:'fr',mcode:'+33',key:'France +33'},
{code:'gf',mcode:'+594',key:'French Guiana +594'},
{code:'pf',mcode:'+689',key:'French Polynesia +689'},
{code:'ga',mcode:'+241',key:'Gabon +241'},
{code:'gm',mcode:'+220',key:'Gambia +220'},
{code:'ge',mcode:'+7880',key:'Georgia +7880'},
{code:'de',mcode:'+49',key:'Germany +49'},
{code:'gh',mcode:'+233',key:'Ghana +233'},
{code:'gi',mcode:'+350',key:'Gibraltar +350'},
{code:'gr',mcode:'+30',key:'Greece +30'},
{code:'gl',mcode:'+299',key:'Greenland +299'},
{code:'gd',mcode:'+1473',key:'Grenada +1473'},
{code:'gp',mcode:'+590',key:'Guadeloupe +590'},
{code:'gu',mcode:'+671',key:'Guam +671'},
{code:'gt',mcode:'+502',key:'Guatemala +502'},
{code:'gn',mcode:'+224',key:'Guinea +224'},
{code:'gw',mcode:'+245',key:'Guinea - Bissau +245'},
{code:'gy',mcode:'+592',key:'Guyana +592'},
{code:'ht',mcode:'+509',key:'Haiti +509'},
{code:'hn',mcode:'+504',key:'Honduras +504'},
{code:'hk',mcode:'+852',key:'Hong Kong +852'},
{code:'hu',mcode:'+36',key:'Hungary +36'},
{code:'is',mcode:'+354',key:'Iceland +354'},
{code:'in',mcode:'+91',key:'India +91'},
{code:'id',mcode:'+62',key:'Indonesia +62'},
{code:'iq',mcode:'+964',key:'Iraq +964'},
{code:'ir',mcode:'+98',key:'Iran +98'},
{code:'ie',mcode:'+353',key:'Ireland +353'},
{code:'il',mcode:'+972',key:'Israel +972'},
{code:'it',mcode:'+39',key:'Italy +39'},
{code:'jm',mcode:'+1876',key:'Jamaica +1876'},
{code:'jp',mcode:'+81',key:'Japan +81'},
{code:'jo',mcode:'+962',key:'Jordan +962'},
{code:'kz',mcode:'+7',key:'Kazakhstan +7'},
{code:'ke',mcode:'+254',key:'Kenya +254'},
{code:'ki',mcode:'+686',key:'Kiribati +686'},
{code:'kp',mcode:'+850',key:'Korea - North +850'},
{code:'kr',mcode:'+82',key:'Korea - South +82'},
{code:'kw',mcode:'+965',key:'Kuwait +965'},
{code:'kg',mcode:'+996',key:'Kyrgyzstan +996'},
{code:'la',mcode:'+856',key:'Laos +856'},
{code:'lv',mcode:'+371',key:'Latvia +371'},
{code:'lb',mcode:'+961',key:'Lebanon +961'},
{code:'ls',mcode:'+266',key:'Lesotho +266'},
{code:'lr',mcode:'+231',key:'Liberia +231'},
{code:'ly',mcode:'+218',key:'Libya +218'},
{code:'li',mcode:'+417',key:'Liechtenstein +417'},
{code:'lt',mcode:'+370',key:'Lithuania +370'},
{code:'lu',mcode:'+352',key:'Luxembourg +352'},
{code:'mo',mcode:'+853',key:'Macao +853'},
{code:'mk',mcode:'+389',key:'Macedonia +389'},
{code:'mg',mcode:'+261',key:'Madagascar +261'},
{code:'mw',mcode:'+265',key:'Malawi +265'},
{code:'my',mcode:'+60',key:'Malaysia +60'},
{code:'mv',mcode:'+960',key:'Maldives +960'},
{code:'ml',mcode:'+223',key:'Mali +223'},
{code:'mt',mcode:'+356',key:'Malta +356'},
{code:'mh',mcode:'+692',key:'Marshall Islands +692'},
{code:'mq',mcode:'+596',key:'Martinique +596'},
{code:'mr',mcode:'+222',key:'Mauritania +222'},
{code:'yt',mcode:'+269',key:'Mayotte +269'},
{code:'mx',mcode:'+52',key:'Mexico +52'},
{code:'fm',mcode:'+691',key:'Micronesia +691'},
{code:'md',mcode:'+373',key:'Moldova +373'},
{code:'mc',mcode:'+377',key:'Monaco +377'},
{code:'mn',mcode:'+976',key:'Mongolia +976'},
{code:'ms',mcode:'+1664',key:'Montserrat +1664'},
{code:'ma',mcode:'+212',key:'Morocco +212'},
{code:'mz',mcode:'+258',key:'Mozambique +258'},
{code:'mn',mcode:'+95',key:'Myanmar +95'},
{code:'na',mcode:'+264',key:'Namibia +264'},
{code:'nr',mcode:'+674',key:'Nauru +674'},
{code:'np',mcode:'+977',key:'Nepal +977'},
{code:'nl',mcode:'+31',key:'Netherlands +31'},
{code:'nc',mcode:'+687',key:'New Caledonia +687'},
{code:'nz',mcode:'+64',key:'New Zealand +64'},
{code:'ni',mcode:'+505',key:'Nicaragua +505'},
{code:'ne',mcode:'+227',key:'Niger +227'},
{code:'ng',mcode:'+234',key:'Nigeria +234'},
{code:'nu',mcode:'+683',key:'Niue +683'},
{code:'nf',mcode:'+672',key:'Norfolk Islands +672'},
{code:'np',mcode:'+670',key:'Northern Marianas +670'},
{code:'no',mcode:'+47',key:'Norway +47'},
{code:'om',mcode:'+968',key:'Oman +968'},
{code:'pk',mcode:'+92',key:'Pakistan +92'},
{code:'pw',mcode:'+680',key:'Palau +680'},
{code:'pa',mcode:'+507',key:'Panama +507'},
{code:'pg',mcode:'+675',key:'Papua New Guinea +675'},
{code:'py',mcode:'+595',key:'Paraguay +595'},
{code:'pe',mcode:'+51',key:'Peru +51'},
{code:'ph',mcode:'+63',key:'Philippines +63'},
{code:'pl',mcode:'+48',key:'Poland +48'},
{code:'pt',mcode:'+351',key:'Portugal +351'},
{code:'pr',mcode:'+1787',key:'Puerto Rico +1787'},
{code:'qa',mcode:'+974',key:'Qatar +974'},
{code:'re',mcode:'+262',key:'Reunion +262'},
{code:'ro',mcode:'+40',key:'Romania +40'},
{code:'ru',mcode:'+7',key:'Russia +7'},
{code:'rw',mcode:'+250',key:'Rwanda +250'},
{code:'sm',mcode:'+378',key:'San Marino +378'},
{code:'st',mcode:'+239',key:'Sao Tome &amp; Principe +239'},
{code:'sa',mcode:'+966',key:'Saudi Arabia +966'},
{code:'sn',mcode:'+221',key:'Senegal +221'},
{code:'cs',mcode:'+381',key:'Serbia +381'},
{code:'sc',mcode:'+248',key:'Seychelles +248'},
{code:'sl',mcode:'+232',key:'Sierra Leone +232'},
{code:'sg',mcode:'+65',key:'Singapore +65'},
{code:'sk',mcode:'+421',key:'Slovak Republic +421'},
{code:'si',mcode:'+386',key:'Slovenia +386'},
{code:'sb',mcode:'+677',key:'Solomon Islands +677'},
{code:'so',mcode:'+252',key:'Somalia +252'},
{code:'za',mcode:'+27',key:'South Africa +27'},
{code:'es',mcode:'+34',key:'Spain +34'},
{code:'lk',mcode:'+94',key:'Sri Lanka +94'},
{code:'sh',mcode:'+290',key:'St. Helena +290'},
{code:'kn',mcode:'+1869',key:'St. Kitts +1869'},
{code:'sc',mcode:'+1758',key:'St. Lucia +1758'},
{code:'sr',mcode:'+597',key:'Suriname +597'},
{code:'sd',mcode:'+249',key:'Sudan +249'},
{code:'sz',mcode:'+268',key:'Swaziland +268'},
{code:'se',mcode:'+46',key:'Sweden +46'},
{code:'ch',mcode:'+41',key:'Switzerland +41'},
{code:'sy',mcode:'+963',key:'Syria +963'},
{code:'tw',mcode:'+886',key:'Taiwan +886'},
{code:'tj',mcode:'+992',key:'Tajikistan +992'},
{code:'th',mcode:'+66',key:'Thailand +66'},
{code:'tg',mcode:'+228',key:'Togo +228'},
{code:'to',mcode:'+676',key:'Tonga +676'},
{code:'tt',mcode:'+1868',key:'Trinidad &amp; Tobago +1868'},
{code:'tn',mcode:'+216',key:'Tunisia +216'},
{code:'tr',mcode:'+90',key:'Turkey +90'},
{code:'tm',mcode:'+993',key:'Turkmenistan +993'},
{code:'tc',mcode:'+1649',key:'Turks &amp; Caicos Islands +1649'},
{code:'tv',mcode:'+688',key:'Tuvalu +688'},
{code:'ug',mcode:'+256',key:'Uganda +256'},
{code:'ua',mcode:'+380',key:'Ukraine +380'},
{code:'ae',mcode:'+971',key:'United Arab Emirates +971'},
{code:'uy',mcode:'+598',key:'Uruguay +598'},
{code:'uz',mcode:'+998',key:'Uzbekistan +998'},
{code:'vu',mcode:'+678',key:'Vanuatu +678'},
{code:'va',mcode:'+379',key:'Vatican City +379'},
{code:'ve',mcode:'+58',key:'Venezuela +58'},
{code:'vn',mcode:'+84',key:'Vietnam +84'},
{code:'vg',mcode:'+1',key:'Virgin Islands - British +1'},
{code:'vi',mcode:'+1',key:'Virgin Islands - US +1'},
{code:'wf',mcode:'+681',key:'Wallis &amp; Futuna +681'},
{code:'ye',mcode:'+969',key:'Yemen North +969'},
{code:'ye',mcode:'+967',key:'Yemen South +967'},
{code:'zm',mcode:'+260',key:'Zambia +260'},
{code:'zw',mcode:'+263',key:'Zimbabwe +263'}]
 initPhoneHtml();